import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  Input,
  TemplateRef,
  ContentChild,
  ElementRef,
} from '@angular/core';

export interface StepTitles {
  title: string;
  subtitle?: string;
  leftLabel?: string;
  data: any;
}

@Component({
  selector: 'itfg-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TimelineComponent implements OnInit {
  @ViewChild('timeline') timeline!: ElementRef;
  @Input() enableStepTransitionButtons: Boolean = false;
  @Input() stepConfigurations: StepTitles[] = [];

  @ContentChild('stepContent')
  stepContent: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

  goToNextStep() {
    // TODO: add if needed
  }
}